import { cloneDeep } from 'lodash';
const SET_ACTIVE_ENROLL_STEP = 'SET_ENROLL_STEP';
const ENROLL_CREATE_ACCOUNT = 'enrollCreateAccount';
const ENROLL_CHECKOUT = 'enrollCheckout';
const ENROLL_UPDATE_CUSTOMER_INFO = 'enrollUpdateCustomerInfo';

const initialState = ENROLL_CREATE_ACCOUNT;

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_ACTIVE_ENROLL_STEP:
			return action.payload;
		default:
			return state;
	}
}

export function activeStepCreate(){
	return{
		type: SET_ACTIVE_ENROLL_STEP,
		payload: ENROLL_CREATE_ACCOUNT
	}
}

export function activeStepCheckout(){
	return{
		type: SET_ACTIVE_ENROLL_STEP,
		payload: ENROLL_CHECKOUT
	}
}

export function activeStepUpdate(){
	return{
		type: SET_ACTIVE_ENROLL_STEP,
		payload: ENROLL_UPDATE_CUSTOMER_INFO
	}
}



// WEBPACK FOOTER //
// ./src/modules/active_enroll_step.js